(function () {
  // Pin the collection slider directly under whatever header is fixed at the top (mobile).
  function syncTop() {
    var sec = document.querySelector('.index-section--collnav');
    if (!sec) return;
    if (window.innerWidth > 768) { sec.style.removeProperty('top'); return; }
    var candidates = [
      document.querySelector('.header-sticky-wrapper'),
      document.querySelector('.site-header'),
      document.querySelector('.shopify-section-header'),
      document.querySelector('.shopify-section-group-header-group')
    ];
    var off = 0;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el || el.contains(sec)) continue;
      var cs = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 1 && r.height > 0) {
        if (r.bottom > off) off = r.bottom;
      }
    }
    sec.style.setProperty('top', Math.round(off) + 'px', 'important');
  }

  // Rename the best-sellers "View all" link to "View Best Sellers" (scoped to section header link).
  function renameViewAll() {
    var els = document.querySelectorAll('.section-header__link[href*="/best-sellers"]');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === 'view all') { els[i].textContent = 'View Best Sellers'; }
    }
  }

  function wire() {
    var navs = document.querySelectorAll('[data-rm-collnav]');
    for (var i = 0; i < navs.length; i++) {
      (function (nav) {
        var track = nav.querySelector('[data-collnav-scroll]');
        var bar = nav.querySelector('.rm-collnav__bar');
        var thumb = nav.querySelector('[data-collnav-thumb]');
        if (!track || !thumb || !bar) return;
        function update() {
          var sw = track.scrollWidth, cw = track.clientWidth;
          if (sw <= cw + 2) { bar.style.display = 'none'; return; }
          bar.style.display = '';
          var ratio = cw / sw;
          var thumbW = Math.max(ratio * 100, 16);
          thumb.style.width = thumbW + '%';
          var maxScroll = sw - cw;
          var pos = maxScroll ? (track.scrollLeft / maxScroll) : 0;
          thumb.style.left = (pos * (100 - thumbW)) + '%';
        }
        function flash() {
          nav.classList.add('is-scrolling');
          clearTimeout(nav.__rmT);
          nav.__rmT = setTimeout(function () { nav.classList.remove('is-scrolling'); }, 850);
        }
        if (!track.__rmWired) {
          track.__rmWired = true;
          track.addEventListener('scroll', function () { update(); flash(); }, { passive: true });
          track.addEventListener('touchstart', flash, { passive: true });
          window.addEventListener('resize', update);
          var active = track.querySelector('.rm-collnav__item.is-active');
          if (active) { try { track.scrollLeft = active.offsetLeft - (track.clientWidth / 2) + (active.offsetWidth / 2); } catch (e) {} }
        }
        update();
      })(navs[i]);
    }
  }

  function init() { wire(); syncTop(); renameViewAll(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  window.addEventListener('pageshow', init);
  window.addEventListener('scroll', syncTop, { passive: true });
  window.addEventListener('resize', syncTop);
  setInterval(init, 30000); // slow safety net (was 2s)
})();
